import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

import { MATCH_HISTORY_SEARCH } from "MVVM/GraphQL/matchHistorySearch";

const MatchHistorySearchViewModel = () => {
  const [playerSearchQueryRaw, { data, error, loading }] =
    useLazyQuery(MATCH_HISTORY_SEARCH);
  const playerSearchQuery = useCallback(playerSearchQueryRaw, [
    playerSearchQueryRaw,
  ]);

  return {
    data,
    error,
    loading,
    playerSearchQuery,
  };
};

export { MatchHistorySearchViewModel };
